import { Link } from "@inertiajs/react"

import PlatformIcon from "@/components/icons/platform-icon"
import { storyPath } from "@/routes"
import type { QuotableTake } from "@/types"

function quotedTakeLabel(quotedTake: QuotableTake) {
  const heading = `Take ${quotedTake.position + 1}`
  return quotedTake.label ? `${heading}: ${quotedTake.label}` : heading
}

export default function QuotedTakeReference({
  quotedTake,
}: {
  quotedTake: QuotableTake
}) {
  return (
    <Link
      href={storyPath(quotedTake.story_id)}
      className="hover:bg-muted/50 flex flex-col gap-2 rounded-xl border p-3 transition-colors"
    >
      <p className="text-muted-foreground text-xs font-medium tracking-widest uppercase">
        Quotes
      </p>
      <div className="flex items-center justify-between gap-3">
        <span className="truncate text-sm">{quotedTakeLabel(quotedTake)}</span>
        {quotedTake.published_platforms.length > 0 && (
          <span className="flex shrink-0 items-center gap-1">
            {quotedTake.published_platforms.map((platform) => (
              <PlatformIcon
                key={platform.id}
                platform={platform.name}
                className="size-3.5"
              />
            ))}
          </span>
        )}
      </div>
    </Link>
  )
}
